import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=fbf442ec&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf442ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbf442ec')) {
      api.createRecord('fbf442ec', component.options)
    } else {
      api.reload('fbf442ec', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=fbf442ec&scoped=true&", function () {
      api.rerender('fbf442ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lbuk5VZWZ3dF/JS/comp/Accordion.vue"
export default component.exports